import { Box, CircularProgress } from '@material-ui/core';
import { IntegrationType, SignatureUrls } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { NemuruDialog } from '@/components/shared/components/NemuruDialog';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';

interface RedirectEmbeddedSignatureProps {
  signatureUrls: SignatureUrls;
  requiresResignature?: boolean;
  disabled?: boolean;
}

export const RedirectEmbeddedSignature = ({
  signatureUrls,
  requiresResignature,
  disabled,
}: RedirectEmbeddedSignatureProps) => {
  const { md } = useScreen();
  const { palette } = useCustomTheme();

  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);

  const { url, integrationType } = signatureUrls;

  if (!url || integrationType !== IntegrationType.REDIRECT) {
    return null;
  }

  const onMount = async () => {
    setShowDialog(true);
    setLoading(true);
    try {
      //await waitForFormAndSubmit();
    } catch (err) {
      // Handle the error, e.g., show a message to the user
      console.error(err);
    }
    setLoading(false);
  };

  return (
    <>
      <Box flexShrink={0}>
        {loading ? (
          <CircularProgress size={18} style={{ color: palette.secondary.main }} />
        ) : (
          <StandardButton main size="small" onClick={onMount} disabled={showDialog || disabled}>
            <Text tId={requiresResignature ? 'RESIGNATURE_CONTRACT' : 'SIGN_CONTRACT'} />
          </StandardButton>
        )}
      </Box>
      <NemuruDialog
        opened={showDialog}
        setOpened={setShowDialog}
        buttons={
          <>
            <StandardButton variant="outlined" onClick={() => window.open(url, '_blank')}>
              <Text tId={'OPEN_IN_NEW_TAB'} />
            </StandardButton>
          </>
        }
      >
        {/*{signatureCompleted && <SignatureCompleted />}*/}
        {/*{!signatureCompleted && (*/}
        <iframe
          name="signature-iframe"
          id="signature-iframe"
          allowFullScreen
          allow="camera; microphone; geolocation; fullscreen; clipboard-read; clipboard-write"
          src={url}
          style={{
            height: md ? '700px' : 'calc(100vh - 150px)',
            width: '100%',
            border: 0,
          }}
        />
      </NemuruDialog>
    </>
  );
};
